import React, { useState, useRef, useEffect } from "react";
import PropTypes from "prop-types";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import Button from "react-bootstrap/Button";
import { BsSearch } from "react-icons/bs";

const SearchInputs = ({
  emailList,
  onFilterApplied,
  isFilterOn,
  ownerEmail
}) => {
  const [selectedOption, setSelectedOption] = useState("from");
  const [searchTerm, setSearchTerm] = useState("");

  const inputRef = useRef(null);

  useEffect(() => {
    return () => {
      setSelectedOption("from");
      setSearchTerm("");
      onFilterApplied(emailList);
    };
  }, []);

  const onDropdownChange = (e) => {
    if (e === "Unread" || e === "All") {
      filterEmails(searchTerm, e);
      setSelectedOption(e);
      return;
    }
    if (searchTerm.length >= 3) {
      filterEmails(searchTerm, e);
    }
    setSelectedOption(e);
    inputRef?.current?.focus();
  };

  const onSearchClick = () => {
    filterEmails(searchTerm, selectedOption);
  };

  const filterEmails = (term, selectedOption) => {
    const allEmails = isFilterOn
      ? emailList.filter((email) => email.assignTo === ownerEmail)
      : emailList;
    if (term.length >= 3 || selectedOption === "Unread") {
      const filteredEmails = allEmails.filter((email) => {
        switch (selectedOption) {
          case "Sent to":
            return email?.toAddresses.find((el) =>
              el.toLowerCase().includes(term.toLowerCase())
            );
          case "from":
            return email?.from.toLowerCase().includes(term.toLowerCase());
          case "Assignee":
            return email?.assignTo.toLowerCase().includes(term.toLowerCase());
          case "Subject":
            return email?.subject.toLowerCase().includes(term.toLowerCase());
          case "Body":
            return email?.body.toLowerCase().includes(term.toLowerCase());
          case "Unread":
            return email.read === false;
          default:
            return false;
        }
      });
      onFilterApplied(filteredEmails);
    } else {
      onFilterApplied(allEmails);
    }
  };

  const onSearchValueChanged = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    setTimeout(() => {
      filterEmails(value, selectedOption);
    }, 300);
  };

  return (
    <>
      <InputGroup className="mb-1" size="sm">
        <DropdownButton
          variant="light"
          title={selectedOption}
          onSelect={onDropdownChange}
        >
          <Dropdown.Item disabled> Filter by: </Dropdown.Item>

          <Dropdown.Item eventKey="from">from</Dropdown.Item>
          <Dropdown.Item eventKey="Sent to">Sent to</Dropdown.Item>
          <Dropdown.Item eventKey="Assignee">Assignee</Dropdown.Item>
          <Dropdown.Item eventKey="Subject">Subject</Dropdown.Item>
          <Dropdown.Item eventKey="Body">Body</Dropdown.Item>
          <Dropdown.Divider></Dropdown.Divider>
          <Dropdown.Item eventKey="Unread">Unread</Dropdown.Item>
          <Dropdown.Item eventKey="All">Show All</Dropdown.Item>
        </DropdownButton>
        <Form.Control
          ref={inputRef}
          aria-label="Text input with dropdown button"
          placeholder="enter search value (min 3 characters)"
          value={searchTerm}
          onChange={onSearchValueChanged}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              onSearchClick();
            }
          }}
        />
        <Button variant="light" className="border" onClick={onSearchClick}>
          <BsSearch size={17} />
        </Button>
      </InputGroup>
    </>
  );
};

SearchInputs.propTypes = {
  emailList: PropTypes.arrayOf(
    PropTypes.shape({
      toAddresses: PropTypes.arrayOf(PropTypes.string),
      from: PropTypes.string,
      assignTo: PropTypes.string,
      subject: PropTypes.string,
      body: PropTypes.string
    })
  ).isRequired,
  onFilterApplied: PropTypes.func.isRequired,
  isFilterOn: PropTypes.bool.isRequired,
  ownerEmail: PropTypes.string.isRequired
};

export default SearchInputs;
